import { render, staticRenderFns } from "./xl-release.vue?vue&type=template&id=16f7f87a&scoped=true"
import script from "./xl-release.vue?vue&type=script&lang=js"
export * from "./xl-release.vue?vue&type=script&lang=js"
import style0 from "./xl-release.vue?vue&type=style&index=0&id=16f7f87a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f7f87a",
  null
  
)

export default component.exports